import React, { useCallback, useEffect, useState } from 'react';
import { Box, Container, Grid, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import api, { ENGINE } from '../../infrastructure/config/api';
import Button from '../components/common/Button';
import {
  EnginePositionsTable,
  EngineStatusCard,
  EngineSummaryCards,
} from '../components/engine';

const EngineDashboard = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [symbol, setSymbol] = useState('BTCUSDT');
  const [timeframe, setTimeframe] = useState('15m');
  const [loading, setLoading] = useState(false);
  const [statusData, setStatusData] = useState(null);
  const [positionsData, setPositionsData] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [statusRes, positionsRes] = await Promise.all([
        api.get(ENGINE.STATUS, { params: { symbol, timeframe } }),
        api.get(ENGINE.POSITIONS, { params: { symbol } }),
      ]);

      setStatusData(statusRes.data?.data || null);
      setPositionsData(positionsRes.data?.data || null);
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || 'Failed to load engine dashboard', {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, symbol, timeframe]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 6 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4">Engine Dashboard</Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <TextField
          label="Symbol"
          size="small"
          value={symbol}
          onChange={(e) => setSymbol(String(e.target.value || '').toUpperCase())}
        />
        <TextField
          label="Timeframe"
          size="small"
          value={timeframe}
          onChange={(e) => setTimeframe(e.target.value)}
        />
        <Button variant="contained" onClick={fetchData} loading={loading}>Refresh</Button>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <EngineStatusCard data={statusData} loading={loading} onRefresh={fetchData} />
        </Grid>
        <Grid item xs={12}>
          <EngineSummaryCards summary={positionsData?.summary} />
        </Grid>
        <Grid item xs={12}>
          <EnginePositionsTable rows={positionsData?.runningTrades || []} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default EngineDashboard;
